export default __webpack_public_path__ + "static/media/working-with-us-full-HD.1bab9e6f.jpg";